var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58339 9.43334L10.7124 6.30434L11.5372 7.12917L7.00006 11.6663L2.46289 7.12917L3.28772 6.30434L6.41672 9.43334V2.33301H7.58339V9.43334Z",
    fill: "#62616F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIcon);
export default __webpack_public_path__ + "static/media/down_arrow_icon.2d681473f814f34bac9e5b68e292752d.svg";
export { ForwardRef as ReactComponent };